import { SCENE_COMMON_TOKEN, SceneCommon } from '@cgs/common';
import { Container, SceneObject } from '@cgs/wge';
import {
  RESOURCES_COMPONENT_TOKEN,
  T_GameStateMachineNotifierComponent,
} from '../../../type_definitions';
import { ISlotPopupView } from '../../common/base_slot_view';
import { BaseSlotPopupController } from '../../common/slot/controllers/base_popup_controller';
import { SLOT_SESSION_TOKEN, SlotSession } from '../../common/slot_session';
import { GameStateMachineNotifierComponent } from '../game_state_machine_notifier_component';
import { ResourcesComponent } from '../resources_component';
import {
  IPopupHolderComponent,
  POPUP_HOLDER_COMPONENT_TOKEN,
} from '../../../ui/popup/popup-holder.component';

export class BasePopupComponent<T extends ISlotPopupView> {
  private _popupController: BaseSlotPopupController<T>;
  private readonly _notifier: GameStateMachineNotifierComponent;
  private readonly _slotSession: SlotSession;
  private readonly _popupScene: SceneObject;
  private readonly _popupSoundScene: SceneObject | null;
  private readonly _rootScene: SceneObject;

  protected controllers: BaseSlotPopupController<T>[] = [];

  constructor(
    container: Container,
    sceneName: string,
    existingScene?: boolean,
    soundSceneName?: string
  ) {
    this._notifier = container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    );
    const popupHolder = container.resolve<IPopupHolderComponent>(POPUP_HOLDER_COMPONENT_TOKEN, {
      optional: true,
    });
    this._rootScene =
      popupHolder?.scene ?? container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN).root;
    const sceneCommon = container.resolve<SceneCommon>(SCENE_COMMON_TOKEN);
    this._popupScene = existingScene
      ? this._rootScene.findById(sceneName)!
      : sceneCommon.sceneFactory.build(sceneName)!;

    this._popupSoundScene = soundSceneName ? sceneCommon.sceneFactory.build(soundSceneName) : null;
    this._slotSession = container.resolve<SlotSession>(SLOT_SESSION_TOKEN);
  }

  public get slotSession(): SlotSession {
    return this._slotSession;
  }

  public get notifier(): GameStateMachineNotifierComponent {
    return this._notifier;
  }

  public get popupScene(): SceneObject {
    return this._popupScene;
  }

  public get popupSoundScene(): SceneObject | null {
    return this._popupSoundScene;
  }

  public get rootScene(): SceneObject {
    return this._rootScene;
  }

  public get popupController(): BaseSlotPopupController<T> {
    return this._popupController;
  }

  public set popupController(value: BaseSlotPopupController<T>) {
    this._popupController = value;
  }
}
